import React from "react"
import styled, { css } from "styled-components"
import { Button } from "buoy-core"
import { colors } from "buoy-theme"
import HeaderLabel from "../HeaderLabel"
import { SOMETHING_ELSE, UNSURE } from "../../../../constants"
import ThankYou from "../../../ThankYou"
import { OptionContainer, Option, OptionLabel } from "../../../tagging/common"
import CloseIcon from "../../../../../common/components/icons/CloseIcon"
import { TextArea } from "../../../../../common/components/Input"

const FeedbackButton = styled(Button)`
  ${props =>
    props.disable
      ? css`
          opacity: 0.5;
          cursor: not-allowed;
        `
      : ""};
`

const Feedback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const FeedbackText = styled(TextArea)`
  height: 68px;
  :focus {
    border-color: ${colors.primary};
  }
  ${props =>
    props.disable
      ? css`
          opacity: 0.5;
          cursor: not-allowed;
          pointer-events: none;
        `
      : ""};
`

const GeneralOptions = ({
  showPopUp,
  submitFollowUp,
  submitted,
  response,
  postIntent,
  options,
  text,
  setText,
  submitFollowUpText,
}) => {
  return (
    <React.Fragment>
      <CloseIcon onClick={showPopUp(false)} color="#96cdff" />
      <HeaderLabel>{postIntent.header}</HeaderLabel>
      <OptionLabel disable={submitted} color="white" block fontWeight="regular">
        What do you plan to do next?
      </OptionLabel>
      <OptionContainer>
        {options.map(o => (
          <Option
            key={o.token}
            disable={submitted}
            onClick={submitFollowUp(o.token)}
            selected={o.token === response}
            borderColor="white"
          >
            {o.text}
          </Option>
        ))}
      </OptionContainer>
      {(response === SOMETHING_ELSE || response === UNSURE) && (
        <Feedback>
          <FeedbackText
            value={text}
            disabled={submitted}
            disable={submitted}
            onChange={setText}
            placeholder="What are you considering?"
          />
          {!submitted && (
            <FeedbackButton
              onClick={submitFollowUpText(response, text)}
              disable={submitted}
              color="white"
              textColor="primary"
              margin="12px 0"
              borderColor="white"
            >
              Submit
            </FeedbackButton>
          )}
        </Feedback>
      )}
      {submitted && (
        <ThankYou
          feedback={response === SOMETHING_ELSE || response === UNSURE}
        />
      )}
    </React.Fragment>
  )
}

export default GeneralOptions



// WEBPACK FOOTER //
// ./assets/feedback/components/postIntent/components/options/GeneralOptions.js